/** Traduction des codes d'erreur d'API (`errors.<code>` de `fr.json`) ; hors composant, toujours ce singleton. */
import { FormatIcu } from '@tolgee/format-icu';
import { TolgeeCore, VueTolgee } from '@tolgee/vue';
import type { ErrorCode } from '@/api/generated/types.gen';
import fr from './fr.json';

// TolgeeCore et pas Tolgee() : ce dernier ajoute BrowserExtensionPlugin (script distant injectable).
export const tolgee = TolgeeCore().use(FormatIcu()).init({
  language: 'fr', // sans lui, t() rend la CLÉ tant que run() n'a pas tourné
  defaultLanguage: 'fr',
  fallbackLanguage: 'fr',
  availableLanguages: ['fr'],
  staticData: { fr }, // mis en cache par init(), synchrone
  onFormatError: () => '', // param manquant / ICU invalide ⇒ '' ⇒ repli de l'appelant
});
export { VueTolgee };

/** Texte FR du code, ou null (clé absente, `internal_error`, formatage impossible). */
export function translateErrorCode(code: ErrorCode, params?: Readonly<Record<string, string | number>> | null): string | null {
  const label = tolgee.t({ key: `errors.${code}`, params: params ? { ...params } : undefined, orEmpty: true, noWrap: true });
  return label === '' ? null : label;
}
